(() => {
  if (customElements.get('pdc-complete-fit')) return;
  let adding = false;
  class PdcCompleteFit extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', (event) => {
        event.stopPropagation();
        const select = event.target.closest('[data-fit-variant]');
        if (!select) return;
        const card = select.closest('[data-fit-product]');
        card.querySelector('[data-fit-add]').disabled = !select.value || select.selectedOptions[0].disabled;
        if (select.value) card.querySelector('[data-fit-price]').textContent = select.selectedOptions[0].dataset.price;
        const image = card.querySelector('img');
        if (image && select.selectedOptions[0].dataset.image) {
          image.removeAttribute('srcset');
          image.src = select.selectedOptions[0].dataset.image;
        }
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-fit-add]');
        if (button) { event.preventDefault(); this.add(button); }
      });
    }
    async add(button) {
      const card = button.closest('[data-fit-product]');
      const select = card.querySelector('[data-fit-variant]');
      if (adding || !select.value || select.selectedOptions[0].disabled) return;
      adding = true;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      const status = this.querySelector('[role="status"]');
      status.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      const pageItems = document.querySelector('cart-items');
      const sections = new Set(['cart-drawer', 'cart-icon-bubble']);
      if (pageItems) pageItems.getSectionsToRender().forEach(s => sections.add(s.section));
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({items:[{id:select.value, quantity:1}], sections:[...sections].slice(0,5), sections_url:window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (!result.sections || [...sections].slice(0,5).some(id => !result.sections[id])) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        const wasDrawer = !!this.closest('cart-drawer');
        if (drawer && wasDrawer) {
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        }
        if (pageItems) {
          pageItems.getSectionsToRender().forEach(s => {
            const target = document.getElementById(s.id);
            const content = new DOMParser().parseFromString(result.sections[s.section], 'text/html').querySelector(s.selector);
            if (target && content) (target.querySelector(s.selector) || target).innerHTML = content.innerHTML;
          });
        }
        if (drawer && !wasDrawer) {
          const updated = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          if (updated) {
            drawer.querySelector('#CartDrawer').innerHTML = updated.innerHTML;
            drawer.querySelector('#CartDrawer-Overlay').addEventListener('click', () => drawer.close());
          }
        }
        const surface = wasDrawer ? drawer : pageItems;
        const message = surface?.querySelector('.pdc-fit__status') || surface?.querySelector('[role="status"]');
        if (message) message.textContent = this.dataset.added;
        const focus = surface?.querySelector('[data-fit-product] summary') || document.querySelector(wasDrawer ? '#CartDrawer-Checkout' : '#checkout');
        requestAnimationFrame(() => focus?.focus());
        document.dispatchEvent(new CustomEvent('pdc:complete-fit-added', {detail:{productId:card.dataset.fitProduct,variantId:select.value}}));
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
      } finally {
        adding = false;
        if (button.isConnected) { button.disabled = false; button.textContent = this.dataset.add; }
      }
    }
  }
  customElements.define('pdc-complete-fit', PdcCompleteFit);
})();
